import { Component, effect, signal, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageOption, LanguageSelectComponent } from './template/language-select/language-select.component';
import { ThemeToggleComponent } from './template/theme-toggle/theme-toggle.component';
import { FooterComponent } from './template/footer/footer.component';
import { SidebarMenuComponent } from './template/sidebar-menu/sidebar-menu.component';
import { TranslationService } from './services/translation.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LanguageSelectComponent, ThemeToggleComponent, FooterComponent, SidebarMenuComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly i18n = inject(TranslationService);
  protected readonly title = signal('kys-frontend');
  protected readonly language = this.i18n.language;
  protected readonly isDark = signal(false);
  protected readonly languages: LanguageOption[] = [
    { code: 'it', label: 'ITA' },
    { code: 'en', label: 'ENG' }
  ];

  constructor() {
    effect(() => {
      const root = document.documentElement;
      if (this.isDark()) {
        root.classList.add('dark');
      } else {
        root.classList.remove('dark');
      }
    });
  }

  protected setLanguage(language: string): void {
    if (this.languages.some((option) => option.code === language)) {
      void this.i18n.setLanguage(language);
    }
  }

  protected toggleTheme(): void {
    this.isDark.update((value) => !value);
  }
}
